import React from 'react';
import ApproveIcon from './approve-icon';
import ArrowIcon from './arrow';
import CrossIcon from './cross';
import DoubleArrowIcon from './double-arrow-icon';
import FullscreenIcon from './fullscreen-icon';
import LogoIcon from './logo-icon';
import PauseIcon from './pause-icon';
import RandomizeIcon from './randomize';
import ResetIcon from './reset-icon';
import Settings1Icon from './settings1-icon';
import Settings2Icon from './settings2-icon';
import StartIcon from './start-icon';
import StopIcon from './stop-icon';
import VotersIcon from './voters-icon';

export const iconTypes = {
  start: <StartIcon />,
  stop: <StopIcon />,
  pause: <PauseIcon />,
  logo: <LogoIcon />,
  randomize: <RandomizeIcon />,
  fullscreen: <FullscreenIcon />,
  cross: <CrossIcon />,
  arrow: <ArrowIcon />,
  voters: <VotersIcon />,
  ['settings-1']: <Settings1Icon />,
  ['settings-2']: <Settings2Icon />,
  ['double-arrow']: <DoubleArrowIcon />,
  reset: <ResetIcon />,
  approve: <ApproveIcon />,
};
